import React from 'react';
import { Layout } from '@pcmp/react-coworker-components';
import {
  useGetV1ConfigQuery,
  useGetV1UsersMeQuery,
} from '@/redux/apis/frontend-api';
import { CreateFreeTextCodeFormWithSubmit } from '@/components/page-widgets/create-code/free-text-form';
import { UserProvider } from '@/components/page-widgets/create-code/context';
import { LoadingProvider } from '@/components/helpers/loading/context';
import { LoadingFullScreen } from '@/components/helpers/loading/index';

const { Container } = Layout;

function FreeTextPage() {
  const { data: userData } = useGetV1UsersMeQuery();
  const { data: configData } = useGetV1ConfigQuery();

  if (!userData) return <LoadingFullScreen />;

  const forceViewerMode =
    configData?.maintenanceStatus?.enabled &&
    configData?.maintenanceStatus?.forceViewerMode;

  return (
    <div
      data-testid="free-text-page"
      className={`pb-[56px] ${
        forceViewerMode ? 'pointer-events-none opacity-50' : ''
      }`}
    >
      <Container className="pt-[52px]">
        <UserProvider user={userData}>
          <LoadingProvider>
            <CreateFreeTextCodeFormWithSubmit />
          </LoadingProvider>
        </UserProvider>
      </Container>
    </div>
  );
}

export default FreeTextPage;
